<div class="container-wrapper">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selected" (selectedTabChange)="changeMenu($event)">
      <span *ngFor="let childItem of childItem">  
          <mat-tab  label={{childItem.name}}>
            <ng-template matTabContent>
              <div class="faq-section">

                <div class="accordian-wrapper" *ngIf="questionsArray.length > 0 && !shimmer">
                  <ul *ngFor="let questionItem of questionsArray | paginate: { itemsPerPage: 10, currentPage: p }">
                    <li (click)="goTosubCategoryAnswers(questionItem.id, questionItem.permalink, questionItem.categoryId)">
                      <h2 class="label">{{ questionItem.title }}</h2>
                      <span class="icon-right-chevron"></span>
                    </li>
                  </ul>
                </div>

                <div class="accordian-wrapper" *ngIf="questionsArray.length == 0 && !shimmer">
                  <ul>
                    <li>
                      <h2 class="label"> No article found </h2>
                    </li>
                  </ul>
                </div>
                
                  <div class="accordian-wrapper" *ngIf="shimmer">
                  <ul>
                    <li>
                      <span class="loading--shimmer w50"></span>
                      <span class="icon-right-chevron"></span>
                    </li>
                    <li>
                      <span class="loading--shimmer w50"></span>
                      <span class="icon-right-chevron"></span>
                    </li>
                    <li>
                      <span class="loading--shimmer w50"></span>
                      <span class="icon-right-chevron"></span>
                    </li>
                    <li>
                      <span class="loading--shimmer w50"></span>
                      <span class="icon-right-chevron"></span>
                    </li>
                    <li>
                      <span class="loading--shimmer w50"></span>
                      <span class="icon-right-chevron"></span>
                    </li>
                  </ul>
                </div>

              </div>
              <pagination-controls (pageChange)="p = $event" class="float-center"></pagination-controls>
            </ng-template>
          </mat-tab>
    </span>
  </mat-tab-group>

  <!-- <app-lets-chat></app-lets-chat> -->
</div>
